import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente } from '../../usuario/usuario-perfil';


/** Acessos permitidos ao KPI de Cross Sell */
export const acessosKPICrossSell: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable()
export class CanActivateKPICrossSell implements CanActivateChild {

    constructor(private authGuard: AuthGuard,
                private authService: AuthService) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosKPICrossSell);
    }
}
